import InteractionHumAlong from '../interactions/humalong/InteractionHumAlong';
import InteractionPlayfulStretching from '../interactions/playful_stretching/InteractionPlayfulStretching';
import InteractionStarBreathing from '../interactions/star_breathing/InteractionStarBreathing';
import { TRACK_SCREENS } from 'game/tracking/stats.js';

export const CURSOR_UP = 'url(assets/ui/marker.png) 16 16, pointer';
export const CURSOR_OVER = 'url(assets/ui/marker_over.png) 16 16, pointer';
export const DEFAULT_PROMPT_TIMEOUT = 15000;

export const BACKGROUND_MUSIC = {
  TITLE_PAGE: 'ss_inific_loop_01',
  MENU_SCREENS: 'ss_inific_loop_05',
  INIFIC_SCREEN: 'ss_inific_loop_06',
  AMBIENT: 'ambient_loop',
};

export const CLICK_TAP_VO = (isDesktop) => {
  return isDesktop ? 'NFC_7.0_108' : 'NFC_7.0_107';
};

export const INTERACTIONS = [
  {
    id: 'star_breathing',
    name: 'Star Breathing',
    default_character: '',
    scene: InteractionStarBreathing,
    backgroundMusic: BACKGROUND_MUSIC.AMBIENT,
  },
  {
    id: 'playful_stretching',
    name: 'Playful Stretching',
    default_character: '',
    scene: InteractionPlayfulStretching,
    backgroundMusic: BACKGROUND_MUSIC.AMBIENT,
  },
  {
    id: 'humalong',
    name: 'Hum a long',
    default_character: '',
    scene: InteractionHumAlong,
  },
];

export const EMOTION_CLICKED_CHAIN = {
  1: ['NFC_2.0_22', 'NFC_2.0_23'],
  2: ['NFC_3.0_49', 'NFC_2.0_23'],
  3: ['NFC_2.0_22', 'NFC_2.0_23'],
  4: ['NFC_5.0_79', 'NFC_2.0_23'],
};

export const EMOTIONS_VO = {
  DETERMINED: 'NFC_7.0_118',
  EXCITED: 'NFC_7.0_119',
  CURIOUS: 'NFC_7.0_120',
  FRUSTRATED: 'NFC_7.0_121',
  NERVOUS: 'NFC_7.0_123',
  SCARED: 'NFC_7.0_122',
  SAD: 'NFC_7.0_124',
};

export const EMOTIONS = {
  DETERMINED: 'DETERMINED',
  EXCITED: 'EXCITED',
  CURIOUS: 'CURIOUS',
  FRUSTRATED: 'FRUSTRATED',
  NERVOUS: 'NERVOUS',
  SCARED: 'SCARED',
  SAD: 'SAD',
};

export const SCENARIO_FEEL_EMOTIONS = [
  { emotion: EMOTIONS.DETERMINED },
  { emotion: EMOTIONS.EXCITED },
  { emotion: EMOTIONS.CURIOUS },
];

export const SCENARIOS = [
  {
    id: 1,
    active: true,
    name: 'Playdate:Tango',
    nameHoverVO: 'NFC_7.0_110',
    interaction: 'star_breathing',
    assetpack: {
      pack: require('../../../assets/assetpack_scenario1.json'),
      keys: ['audiosprites', 'images', 'spritesheets', 'spinescenes'],
    },
    scene_objects: [
      { type: 'rectangle', x: 910, y: 390, w: 1820, h: 780, color: 0x505050 },
      { type: 'rectangle', x: 910, y: 730, w: 1820, h: 100, color: 0xcccccc },
      { type: 'image', x: 910, y: 390, id: 'background01' },
      { type: 'character', id: 'elmo' },
      { type: 'character', id: 'abby' },
      { type: 'character', id: 'tango' },
    ],
    intro: {
      configId: 'intro',
    },
    emotion_check: {
      configId: 'emotion_check',
    },
    emotion_notice: {
      configId: 'emotion_notice',
    },
    emotion_feel: {
      configId: 'emotion_feel',
      emotions: [...SCENARIO_FEEL_EMOTIONS],
      emotionId: EMOTIONS.FRUSTRATED,
    },
    emotion_interaction: {
      configId: 'emotion_interaction',
    },
    outro: {
      configId: 'outro',
    },
    tracking: {
      names: TRACK_SCREENS.playdate1,
      questionId: 'NFC_2.0_19',
    },
  },
  {
    id: 2,
    active: true,
    name: 'Party Arrival',
    nameHoverVO: 'NFC_7.0_109',
    interaction: 'humalong',
    background_music: 'party_bg',
    assetpack: {
      pack: require('../../../assets/assetpack_scenario2.json'),
      keys: ['audiosprites', 'images', 'spritesheets', 'spinescenes'],
    },
    scene_objects: [
      { type: 'rectangle', x: 910, y: 390, w: 1820, h: 780, color: 0x505050 },
      { type: 'rectangle', x: 910, y: 730, w: 1820, h: 100, color: 0xcccccc },
      { type: 'image', x: 910, y: 390, id: 'background01' },
      { type: 'character', id: 'elmo' },
      { type: 'character', id: 'big_bird' },
    ],
    intro: {
      configId: 'intro',
    },
    emotion_check: {
      configId: 'emotion_check',
    },
    emotion_notice: {
      configId: 'emotion_notice',
    },
    emotion_feel: {
      configId: 'emotion_feel',
      emotions: [{ emotion: EMOTIONS.EXCITED }, { emotion: EMOTIONS.CURIOUS }],
      emotionId: EMOTIONS.NERVOUS,
    },
    emotion_interaction: {
      configId: 'emotion_interaction',
    },
    outro: {
      configId: 'outro',
    },
    tracking: {
      names: TRACK_SCREENS.party,
      questionId: 'NFC_3.0_47',
    },
  },
  {
    id: 3,
    active: true,
    name: 'Playdate:Thunder',
    background_music: 'rain_bg',
    nameHoverVO: 'NFC_7.0_111',
    interaction: 'star_breathing',
    assetpack: {
      pack: require('../../../assets/assetpack_scenario3.json'),
      keys: ['audiosprites', 'images', 'spines', 'spritesheets', 'spinescenes'],
    },
    scene_objects: [
      { type: 'rectangle', x: 910, y: 390, w: 1820, h: 780, color: 0x505050 },
      { type: 'rectangle', x: 910, y: 730, w: 1820, h: 100, color: 0xcccccc },
      { type: 'image', x: 910, y: 390, id: 'background01' },
      { type: 'character', id: 'window' },
      { type: 'character', id: 'abby' },
      { type: 'character', id: 'elmo' },
      { type: 'character', id: 'drawing_table' },
    ],
    intro: {
      configId: 'intro',
    },
    emotion_check: {
      configId: 'emotion_check',
    },
    emotion_notice: {
      configId: 'emotion_notice',
    },
    emotion_feel: {
      configId: 'emotion_feel',
      emotions: [...SCENARIO_FEEL_EMOTIONS],
      emotionId: EMOTIONS.SCARED,
    },
    emotion_interaction: {
      configId: 'emotion_interaction',
    },
    outro: {
      configId: 'outro',
    },
    tracking: {
      names: TRACK_SCREENS.playdate2,
      questionId: 'NFC_2.0_19',
    },
  },
  {
    id: 4,
    active: true,
    name: 'School Gates',
    background_music: 'gates_bg',
    nameHoverVO: 'NFC_7.0_112',
    interaction: 'playful_stretching',
    assetpack: {
      pack: require('../../../assets/assetpack_scenario4.json'),
      keys: ['audiosprites', 'images', 'spritesheets', 'spinescenes'],
    },
    scene_objects: [
      { type: 'rectangle', x: 910, y: 390, w: 1820, h: 780, color: 0x505050 },
      { type: 'rectangle', x: 910, y: 730, w: 1820, h: 100, color: 0xcccccc },
      { type: 'image', x: 910, y: 390, id: 'background01' },
      { type: 'character', id: 'abby' },
      { type: 'character', id: 'big_bird' },
    ],
    intro: {
      configId: 'intro',
    },
    emotion_check: {
      configId: 'emotion_check',
    },
    emotion_notice: {
      configId: 'emotion_notice',
    },
    emotion_feel: {
      configId: 'emotion_feel',
      emotions: [...SCENARIO_FEEL_EMOTIONS],
      emotionId: EMOTIONS.SAD,
    },
    emotion_interaction: {
      configId: 'emotion_interaction',
    },
    outro: {
      configId: 'outro',
    },
    tracking: {
      names: TRACK_SCREENS.school,
      questionId: 'NFC_5.0_77',
    },
  },
];
